<template>
  <div
    v-if="
      !rule.join_fee_reward &&
        !rule.homelesson_reward &&
        !rule.lower_reward &&
        !rule.franchise_reward
    "
  ></div>
  <div id="ratio" v-else>
    <div class="top">
      <h2>提成比例</h2>
    </div>
    <div class="card flex-card" v-if="rule.join_fee_reward || rule.homelesson_reward">
      <div v-if="rule.join_fee_reward" class="figure">
        <h1>{{ rule.join_fee_reward | percentage }}</h1>
        <p>代理费提成</p>
      </div>
      <div v-if="rule.homelesson_reward" class="figure">
        <h1>{{ rule.homelesson_reward | percentage }}</h1>
        <p>同城拼课提成</p>
      </div>
    </div>
    <div class="card flex-card" v-if="rule.lower_reward || rule.franchise_reward">
      <div v-if="rule.lower_reward" class="figure">
        <h1>{{ rule.lower_reward | percentage }}</h1>
        <p>下级收入提成</p>
      </div>
      <div v-if="rule.franchise_reward" class="figure">
        <h1>{{ rule.franchise_reward | percentage }}</h1>
        <p>加盟商分成</p>
      </div>
      <div v-if="rule.multiple_reward" class="figure">
        <h1>{{ rule.multiple_reward | percentage }}</h1>
        <p>多级提成</p>
      </div>
    </div>
  </div>
</template>
<script>
import { percentage } from "./utils"
export default {
  name: "ratio",
  props: ["rule"],
  filters: {
    percentage,
  },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
